'use strict';

if (!Array.of) {
  require('./array-of');
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/array.of/detect.js
 ** module id = 3
 ** module chunks = 0
 **/